import { useRemoveOrderProduct } from "./useRemoveOrderProduct";
import { useUpdateOrderInfo } from "./useUpdateOrderInfo";
import { useOrderById } from "./useOrderById";
import { useGetEstimatedDeliveryDate } from "./useGetEstimatedDeliveryDate";
import { useGetBankHolidays } from "../bankHolidays";
import { useConfirmOrder } from "./useConfirmOrder";
import { useAddOrderProduct } from "./useAddOrderProduct";
import { useAddOrderProducts } from "./useAddOrderProducts";
import { useRemoveOrderProducts } from "./useRemoveOrderProducts";
import { useUpdateProduct } from "../products/useUpdateProduct";
import { useUpdateProducts } from "../products/useUpdateProducts";
import { useDentistProductPreferences } from "../accountPreferences";
import type { FetchPolicy } from "@apollo/client";

interface Props {
  orderId: string;
  fetchPolicy?: FetchPolicy;
}

export const useOrderConfiguration = ({ orderId, fetchPolicy }: Props) => {
  const {
    order,
    materialAndShadeCatalog,
    isLoading: isOrderByIdLoading,
    error: orderByIdError,
    isEditable,
  } = useOrderById({ orderId, fetchPolicy });
  const { removeOrderProduct } = useRemoveOrderProduct({ orderId });
  const { updateOrderInfo } = useUpdateOrderInfo({ orderId });
  const { getEstimatedDeliveryDate } = useGetEstimatedDeliveryDate({ orderId });
  const { getBankHolidays } = useGetBankHolidays();
  const { confirmOrder } = useConfirmOrder({ orderId });
  const { addOrderProduct, loading: isAddingProduct } = useAddOrderProduct({
    orderId,
  });
  const { addOrderProducts, loading: isAddingProducts } = useAddOrderProducts({
    orderId,
  });
  const { removeOrderProducts, loading: isRemovingProducts } =
    useRemoveOrderProducts({ orderId });
  const { updateProduct, isUpdating: isUpdatingProduct } = useUpdateProduct({
    orderId,
  });
  const { updateProducts, isUpdatingProducts } = useUpdateProducts({
    orderId,
  });
  const { dentistProductPreferences, isLoading: isLoadingDentistPreferences } =
    useDentistProductPreferences({ dentistId: order?.dentist?.id });

  return {
    order,
    materialAndShadeCatalog,
    isLoading: isOrderByIdLoading,
    error: orderByIdError,
    isEditable,
    updateOrderInfo,
    removeOrderProduct,
    getEstimatedDeliveryDate,
    getBankHolidays,
    confirmOrder,
    addOrderProduct,
    isAddingProduct,
    addOrderProducts,
    isAddingProducts,
    removeOrderProducts,
    isRemovingProducts,
    updateProduct,
    isUpdatingProduct,
    updateProducts,
    isUpdatingProducts,
    dentistProductPreferences,
    isLoadingDentistPreferences,
  };
};
